import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';

import { catchError, retryWhen, map, mergeMap, finalize } from "rxjs/operators";
import { of, throwError } from "rxjs";

import { MessageService } from '../services/message.service';
import { AuthentificationService } from '../services/authentification.service';
import { HttpInProgressService } from '../services/http-in-progress.service';

import { AppInjector } from "../app.injector";

import { MessageObservable } from "../tools/MessageObservable";
import { RequeteModel } from '../models/requete-model';

import { T as Trad } from '../tools/Traductions';

/**
 * Intercepteur HTTP
 * @implements HttpInterceptor
 */
@Injectable()
export class FournisseurInterceptor implements HttpInterceptor {
    public T: (clef, ...params) => string = Trad;

    /**
     * Intercepte la requête HTTP
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let requete = new RequeteModel(req.url);
        AppInjector.get(HttpInProgressService).notifierDebutRequete(requete);

        req = req.clone({
            headers: req.headers.append('X-Requested-With', 'XMLHttpRequest')
        });

        return next.handle(req).pipe(
            finalize(() => this.gestionFinRequete(requete)),
            MessageObservable.MessageOperator(),
            retryWhen(this.gestionRetry),
            catchError(this.gestionErreur));
    }

    /**
     * Gestion de la requête
     * @param requete
     */
    private gestionFinRequete(requete: RequeteModel) {
        AppInjector.get(HttpInProgressService).notifierFinRequete(requete);
    }

    /**
     * Gestion de l'erreur
     * @param err
     */
    private gestionErreur(err: HttpErrorResponse): Observable<any> {
        // L'utilisateur n'a pas les droits
        if (err.status === 403) {
            AppInjector.get(MessageService).envoyerMessage(this.T('message.erreur.paslesdroits'), 'danger');
        }
        return throwError(err);
    }

    /**
     * Gestion du rejeu
     * @param errors
     */
    private gestionRetry(errors: Observable<any>): Observable<any> {
        return errors.pipe(mergeMap(error => {
            // L'utilisateur n'est pas connecté
            if (error.status == 401) {
                let m = AppInjector.get(AuthentificationService).obtenirEstConnecte().pipe(map(estConnecte => {
                    return estConnecte === true;
                }));
                return m;
            }
            return throwError(error);
        }));
    }
}